import api from '../callApi';

const completeSubscribe = (values, collectEmailFor) => {
    const request = {
        email: values.email,
        publisherId: collectEmailFor ? collectEmailFor.publisherId : null,
        partnerId: collectEmailFor ? collectEmailFor.partnerId : null
    };

    return api.post('Newsletter/SubscribeAsync', request).then(response => {
        return response;
    });
};

export default completeSubscribe;
